/** */
import {
  ADD_ONE_CONTACT_TO_STORE,
  ADD_MANY_CONTACTS_TO_STORE,
  ADD_SEARCH_RESULTS_TO_STORE,
  REMOVE_MANY_CONTACTS_FROM_STORE,
  REMOVE_ONE_CONTACT_FROM_STORE,
  LOAD_CONTACTS_TO_STORE,
  UPDATE_CONTACT
} from '../actions/contact';

export default (state = {}, action) => {
  const { type, payload } = action;
  const current_state = state;
  switch (type) {
    case ADD_MANY_CONTACTS_TO_STORE:
      return {
        ...state,
        ...payload.reduce(
          (contacts, contact) => ({
            ...contacts,
            [contact.id]: contact
          }),
          {}
        )
      };
    case ADD_ONE_CONTACT_TO_STORE:
      return {
        [payload.id]: payload,
        ...state
      };
    case ADD_SEARCH_RESULTS_TO_STORE:
      return {
        ...payload.reduce(
          (contacts, contact) => ({
            ...contacts,
            [contact.id]: contact
          }),
          {}
        )
      };
    case LOAD_CONTACTS_TO_STORE:
      return {
        ...payload.reduce(
          (contacts, contact) => ({
            ...contacts,
            [contact.id]: contact
          }),
          {}
        )
      };
    case REMOVE_MANY_CONTACTS_FROM_STORE:
      payload.forEach((id) => delete current_state[id]);
      return {
        ...current_state
      };
    case REMOVE_ONE_CONTACT_FROM_STORE:
      delete current_state[payload];
      return { ...current_state };
    case UPDATE_CONTACT:
      return {
        ...state,
        [payload.id]: {
          ...state[payload.id],
          ...payload
        }
      };
    default:
      return state;
  }
};
